import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('transactions/byAccounts', [
    '~FETCH_BY_ACCOUNTS_TRANSACTIONS',
    'EXPORT_TO_EXCEL'
]);

export const ACTION = actions(TYPE);
